export default "__VITE_ASSET__Ci6Rc_u$__"